<!-- 推荐 -->
<template>
  <div class="mt-16">
    <div class="dis-flx al-c ju-c ss_wh">
      <div class="txt-c">
        <img src="@/assets/image/login/su.png" alt="" style="width:64px;height:64px;" />
        <p class="mt-80 ft-sz-24" style="margin-top: 80px;font-size: 24px;">
          密码重置成功，请返回<span class="ft-co-106 ft-wt cur-poi" @click="jumpLogin">登录</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
// import { register, sendTemplateMail } from "@/api/login";
export default {
  components: {

  },
  data() {

    return {

    };
  },

  watch: {},
  computed: {
  },
  created() {
  },
  mounted() {
    // this.drawLine();
  },
  methods: {
    jumpLogin() {
      this.$router.push({
        name: "login",
        query: {
          name: '1'
        }
      })
    },
    goBootm() {
      this.$emit('activeNum', 2)
    }
  }
};
</script>
<style>
.ft-co-106 {
  color: #1067E0;
}

.ft-wt {
  font-weight: bold;
}

.ss_wh {
  width: 100%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/forgetPassword/sfSuccess.vue